// Curated project cities with primary segment.
// Coordinates match the same 600×640 SVG viewBox as `indiaPath.js`
// (generated from lat/lon by scripts/gen_cities.py).
// `icon` = lucide-react icon name resolved in IndiaMap.jsx.
// Segments are drawn from TES REFERENCE LIST_22-06-2024.xlsx.

export const SERVICE_CITIES = [
  { name: 'Delhi NCR', segment: 'HQ · Metros · Auto · IT',      icon: 'Building2',  x: 191.2, y: 191.2, hq: true },
  { name: 'Amritsar',  segment: 'Hospitality',                   icon: 'Hotel',      x: 148.5, y: 134.1 },
  { name: 'Ludhiana',  segment: 'Automotive',                    icon: 'Car',        x: 167.3, y: 148.1 },
  { name: 'Jodhpur',   segment: 'Solar / Renewable',             icon: 'Sun',        x: 113.2, y: 237.3 },
  { name: 'Bhilwara',  segment: 'Textile',                       icon: 'Shirt',      x: 144.1, y: 254.4 },
  { name: 'Lucknow',   segment: 'Power / Utility',               icon: 'Zap',        x: 265.0, y: 225.6 },
  { name: 'Kolkata',   segment: 'Warehouse / Logistics',         icon: 'Package',    x: 406.9, y: 307.6 },
  { name: 'Ranchi',    segment: 'Dairy',                         icon: 'Wheat',      x: 348.7, y: 292.7 },
  { name: 'Vadodara',  segment: 'Manufacturing',                 icon: 'Factory',    x: 116.3, y: 312.6 },
  { name: 'Mumbai',    segment: 'Metro / Rail · Data Centre',    icon: 'TrainFront', x: 110.2, y: 374.5 },
  { name: 'Hyderabad', segment: 'Data Centre',                   icon: 'Server',     x: 217.8, y: 407.1 },
  { name: 'Chennai',   segment: 'IT · Telecom',                  icon: 'Cpu',        x: 251.9, y: 489.4 },
];
